function initializeSmoothScroll() {
  const smoothScrollElements = document.querySelectorAll('[data-smooth-scroll="true"]');
  
  smoothScrollElements.forEach(element => {
    const track = element.querySelector('.smooth-scroll-track');
    if (!track) return;
    
    const scrollSpeed = parseFloat(element.dataset?.scrollSpeed || '30');
    const autoplay = element.dataset?.autoplay === 'true';
    
    let animationId = null;
    let currentPosition = 0;
    let isPaused = !autoplay;
    let isDragging = false;
    let maxWidth = 0;
    
    const updateMaxWidth = () => {
      maxWidth = track.scrollWidth / 2;
    };
    
    const animate = () => {
      if (isPaused || isDragging) {
        animationId = requestAnimationFrame(animate);
        return;
      }
      
      currentPosition -= scrollSpeed / 60;
      
      if (Math.abs(currentPosition) >= maxWidth) {
        currentPosition = 0;
      }
      
      track.style.transform = `translateX(${currentPosition}px)`;
      
      animationId = requestAnimationFrame(animate);
    };
    
    const startAnimation = () => {
      if (!animationId) {
        updateMaxWidth();
        animate();
      }
    };
    
    const stopAnimation = () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    };
    
    updateMaxWidth();
    startAnimation();
    
    const resizeObserver = new ResizeObserver(() => {
      updateMaxWidth();
    });
    resizeObserver.observe(track);
    
    element.addEventListener('mouseenter', () => {
      if (autoplay) {
        isPaused = true;
      }
    });
    
    element.addEventListener('mouseleave', () => {
      if (autoplay) {
        isPaused = false;
      }
    });
    
    document.addEventListener('visibilitychange', () => {
      if (autoplay) {
        if (document.hidden) {
          isPaused = true;
        } else {
          isPaused = false;
        }
      }
    });

    let startX = 0;
    let dragStartPosition = 0;

    const startDrag = (e) => {
      isDragging = true;
      isPaused = true;
      track.classList.add('dragging');
      
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      dragStartPosition = currentPosition;
      
      e.preventDefault();
    };

    const drag = (e) => {
      if (!isDragging) return;
      
      e.preventDefault();
      const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      const deltaX = currentX - startX;
      
      currentPosition = dragStartPosition + deltaX;
      track.style.transform = `translateX(${currentPosition}px)`;
    };

    const stopDrag = () => {
      if (!isDragging) return;
      
      isDragging = false;
      track.classList.remove('dragging');
      
      while (currentPosition > 0) {
        currentPosition -= maxWidth;
      }
      while (Math.abs(currentPosition) >= maxWidth) {
        currentPosition += maxWidth;
      }
      
      isPaused = !autoplay;
    };

    track.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDrag);
    track.addEventListener('touchstart', startDrag, { passive: false });
    document.addEventListener('touchmove', drag, { passive: false });
    document.addEventListener('touchend', stopDrag);
    track.addEventListener('contextmenu', (e) => e.preventDefault());
    
    const cleanup = () => {
      stopAnimation();
      resizeObserver.disconnect();
      document.removeEventListener('mousemove', drag);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('touchmove', drag);
      document.removeEventListener('touchend', stopDrag);
    };
  });
}

document.addEventListener('DOMContentLoaded', initializeSmoothScroll);

document.addEventListener('shopify:section:load', function() {
  setTimeout(initializeSmoothScroll, 100);
});